import LinkIcon from "@mui/icons-material/Link";
import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { useAnnouncements } from "./AnnoucementsContext";
import { DataGrid } from "@mui/x-data-grid";

const AnnouncementsList = () => {
  const { announcements, setSelectedAnnouncement, setSelectedAnnouncementLog } =
    useAnnouncements();

    const viewEditLinkIcon = (item) => {
      return(
        <Link className= {"hyper-links"} onClick={(e) => {setSelectedAnnouncement(item)}}>
          {item.id}
        </Link>
      )
    }

    const announcementLogsLink = (item) => {
      return (
        <Link
          style={{textDecoration:'none'}}
          className="hyper-links"
          onClick={(e) => {setSelectedAnnouncement(item)}}
        >
          <LinkIcon fontSize="small"/>
        </Link>
      )
    }

    const convertDateISOToUTC = (isoDate) => {
      if( isoDate !==null && isoDate !=="") {
          const date = new Date(isoDate);
          const utcFormatted = `${date.getUTCFullYear()}-${String(date.getUTCMonth()+1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
          return utcFormatted
      } 
      else return ""; 
  }

    const dataGridColumns = [
      { field: 'id', headerName: 'Id', filterable: true, sortable: true, renderCell:(params) => viewEditLinkIcon(params.row)},
      { field: 'title', headerName: 'Title', filterable: true, sortable: true, width:1000 },
      { field: 'agency', headerName: 'Agency', filterable: true, sortable: true, width:200 },
      { field: 'author', headerName: 'Author', filterable: true, sortable: true},
      { field: 'priority', headerName: 'Priority', filterable: true, sortable: true},
      { field:'expirationDate', headerName: 'Expiration Date', filterable: true, sortable: true, width:200, renderCell:(params) => convertDateISOToUTC(params.row.expirationDate) },
      { field: 'logs', headerName: 'Logs', filterable: false, sortable: false, renderCell:(params) =>  announcementLogsLink(params.row) }
    ]
    if (announcements !=null && announcements.length > 0){
      return (
        <DataGrid rows={announcements} columns={dataGridColumns} disableSelectionOnClick  sx={{'& .MuiDataGrid-columnHeaders':{ fontSize:'1rem',fontWeight:'bold',display:'flex'}}}/>
      )
      }
      else
        return(
          <Box sx={{ width: "100%", textAlign: "center", mt: 5 }}>
            <CircularProgress />
          </Box>
        )
      
};

export default AnnouncementsList;
